<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
    >
        <path
            d="M4.66686 7.77739C6.68899 7.77745 8.37702 9.19773 8.79186 11.0946C8.97244 11.9213 8.42728 12.6656 7.7028 12.8844C6.92422 13.1196 5.8897 13.3336 4.66686 13.3336C3.44417 13.3336 2.40896 13.1201 1.62936 12.8836C0.907322 12.6648 0.361342 11.9226 0.541859 11.0946C0.956694 9.19769 2.64468 7.77739 4.66686 7.77739Z"
            fill="#007AFF"
        />
        <path
            d="M11.3333 7.77739C13.3554 7.77739 15.0435 9.19769 15.4583 11.0946C15.6389 11.9212 15.0944 12.6655 14.37 12.8844C13.5914 13.1196 12.5563 13.3336 11.3333 13.3336C10.6756 13.3336 10.0725 13.2721 9.53405 13.1782C10.0339 12.5576 10.2938 11.7232 10.0942 10.8094C9.90539 9.94594 9.51564 9.1575 8.97702 8.49536C9.64979 8.04214 10.4605 7.77741 11.3333 7.77739Z"
            fill="#007AFF"
        />
        <path
            d="M4.66686 2.44458C5.77126 2.44467 6.66667 3.33979 6.66686 4.44458C6.66686 5.54952 5.77138 6.44449 4.66686 6.44458C3.56226 6.44458 2.66686 5.54958 2.66686 4.44458C2.66704 3.33973 3.56238 2.44458 4.66686 2.44458Z"
            fill="#007AFF"
        />
        <path
            d="M11.3333 2.44458C12.4378 2.44458 13.3331 3.33973 13.3333 4.44458C13.3333 5.54958 12.4379 6.44458 11.3333 6.44458C10.2287 6.44451 9.33327 5.54954 9.33327 4.44458C9.33345 3.33977 10.2288 2.44465 11.3333 2.44458Z"
            fill="#007AFF"
        />
    </svg>
</template>
